module.exports = __webpack_public_path__ + "static/media/red_normal_EN.2aea58e2.png";